/**
 * Achievement definitions used by `coreSlice.nextDay`. Each entry is a small
 * predicate over the post-tick state. Extracted from the inline definition
 * so the array (and the evaluation logic) stay testable in isolation.
 */

export const buildAchievementDefs = ({
  state,
  updatedContracts,
  finalVehicles,
  driversAfterLease,
  finalTreasury,
  newPhase,
  dayRevenue,
  dayExpenses,
}) => [
  { id: 'first_contract', condition: () => updatedContracts.length > 0 || state.activeContracts.length > 0, title: 'Premier contrat', message: 'Vous avez signé votre premier contrat !' },
  { id: 'first_profit', condition: () => dayRevenue > dayExpenses, title: 'Dans le vert', message: 'Première journée rentable !' },
  { id: 'fleet_3', condition: () => finalVehicles.length >= 3, title: 'Petite flotte', message: '3 véhicules dans votre flotte.' },
  { id: 'fleet_5', condition: () => finalVehicles.length >= 5, title: 'Flotte établie', message: '5 véhicules ! Vous prenez de l\'ampleur.' },
  { id: 'fleet_10', condition: () => finalVehicles.length >= 10, title: 'Grand patron', message: '10 véhicules — flotte impressionnante !' },
  { id: 'drivers_5', condition: () => driversAfterLease.length >= 5, title: 'Équipe solide', message: '5 chauffeurs dans votre équipe.' },
  { id: 'drivers_10', condition: () => driversAfterLease.length >= 10, title: 'Major du transport', message: '10 chauffeurs à votre service !' },
  { id: 'treasury_50k', condition: () => finalTreasury >= 50000, title: 'Coffre-fort', message: 'Trésorerie au-dessus de 50 000 €.' },
  { id: 'treasury_100k', condition: () => finalTreasury >= 100000, title: 'Capitaliste', message: '100 000 € en trésorerie !' },
  { id: 'month_1', condition: () => state.totalDays >= 30, title: 'Premier mois', message: 'Vous avez survécu 1 mois !' },
  { id: 'month_6', condition: () => state.totalDays >= 180, title: 'Vétéran', message: '6 mois d\'activité. Respect.' },
  { id: 'year_1', condition: () => state.totalDays >= 365, title: 'Anniversaire', message: '1 an d\'activité — joyeux anniversaire !' },
  { id: 'phase_2', condition: () => newPhase >= 2, title: 'Phase 2', message: 'Accès aux contrats Phase 2 !' },
  { id: 'phase_3', condition: () => newPhase >= 3, title: 'Phase 3', message: 'Envergure nationale — Phase 3 atteinte.' },
  { id: 'phase_4', condition: () => newPhase >= 4, title: 'Phase 4', message: 'Leader du marché — Phase 4 !' },
  { id: 'reputation_90', condition: () => state.reputation >= 90, title: 'Excellence', message: 'Réputation au-dessus de 90 — bravo !' },
];
